export interface ParsedLegacyLogEntry {
  id: string;
  header: string;
  content: string;
  isEmpty: boolean;
  occurredAt: string | null;
  sortTime: number | null;
}

const LEGACY_ENTRY_START = /(?:^|\n)-{5}\s+(?=(?:Создание|Изменение|Удаление)\s)/g;
const LEGACY_HEADER_SEPARATOR = /^(.+?):\s*-{5,}\s*(.*)$/s;
const LEGACY_TIMESTAMP = /(\d{2}):(\d{2})\s+(\d{2})\.(\d{2})\.(\d{4})/;

export function normalizeLegacyLineBreaks(value?: string | null): string {
  return (value || '')
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\n')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n');
}

function parseLegacyTimestamp(value: string): { iso: string; sortTime: number } | null {
  const match = value.match(LEGACY_TIMESTAMP);
  if (!match) return null;

  const [, hour, minute, day, month, year] = match;
  const date = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
  );

  if (Number.isNaN(date.getTime())) return null;
  return {
    iso: date.toISOString(),
    sortTime: date.getTime(),
  };
}

export function parseLegacyLogEntries(log?: string | null): ParsedLegacyLogEntry[] {
  const normalized = normalizeLegacyLineBreaks(log).trim();
  if (!normalized) return [];

  const chunks = normalized
    .split(LEGACY_ENTRY_START)
    .map((part) => part.trim())
    .filter(Boolean);

  const parts = chunks.length > 0 ? chunks : [normalized];

  return parts.map((part, index) => {
    const separated = part.match(LEGACY_HEADER_SEPARATOR);
    let header: string;
    let content: string;

    if (separated) {
      header = separated[1].trim();
      content = separated[2].trim();
    } else {
      const [firstLine = '', ...rest] = part.split('\n');
      header = firstLine.trim() || 'Legacy запись';
      content = rest.join('\n').trim() || part;
    }

    const parsedTimestamp = parseLegacyTimestamp(header);
    const isEmpty = content.length === 0;

    return {
      id: `legacy-${index}-${header.slice(0, 40)}`,
      header: header.replace(/:+$/, ''),
      content: isEmpty ? 'В старом журнале нет детализации изменений.' : content,
      isEmpty,
      occurredAt: parsedTimestamp?.iso ?? null,
      sortTime: parsedTimestamp?.sortTime ?? null,
    };
  });
}
